module.exports = __webpack_public_path__ + "img/num_layout_02.e5404f0a.png";